import { ControlRegion } from '../../models/reports/report-control';

/**
 * Configuration for controls that require special region mapping logic.
 * Example: PAYEE_NAME appears in both Document Criteria and Selection Criteria,
 */
export interface SpecialCaseConfig {
  /** The ERF name that requires special handling */
  erfName: string;

  /** Region mappings for this control */
  regionMappings: {
    /** The region name from the component (null = main selection criteria) */
    componentRegion: string | null;

    /** List of control regions that are allowed for this component region */
    allowedControlRegions: ControlRegion[];
  }[];
}

/**
 * Registry of controls requiring special region mapping.
 *
 * Add new special cases here instead of hardcoding them in the service.
 *
 * @example
 * // To add a new special case:
 * {
 *   erfName: 'NEW_SPECIAL_CONTROL',
 *   regionMappings: [
 *     {
 *       componentRegion: 'Some Region',
 *       allowedControlRegions: ['Some Region'],
 *     },
 *   ],
 * }
 */
export const CONTROL_SPECIAL_CASES: SpecialCaseConfig[] = [
  {
    erfName: 'PAYEE_NAME',
    regionMappings: [
      {
        // When shown in Document Criteria component
        componentRegion: 'Document Criteria',
        allowedControlRegions: ['Document Criteria'],
      },
      {
        // When shown in main Selection Criteria component
        componentRegion: null,
        allowedControlRegions: [
          'Header',
          'Selection Type',
        ],
      },
    ],
  },
  // Add more special cases here as needed
];
